var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M8.36719 3.70258V2.08096C8.36719 1.79424 8.47809 1.51926 8.6755 1.31652C8.8729 1.11378 9.14064 0.999878 9.41982 0.999878H19.9461C20.2253 0.999878 20.4931 1.11378 20.6905 1.31652C20.8879 1.51926 20.9988 1.79424 20.9988 2.08096V13.9729C20.9988 14.2596 20.8879 14.5345 20.6905 14.7373C20.4931 14.94 20.2253 15.0539 19.9461 15.0539H17.8409",
    stroke: "#6B798F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M12.5789 8.02722H2.05263C1.47128 8.02722 1 8.51124 1 9.1083V19.9191C1 20.5162 1.47128 21.0002 2.05263 21.0002H12.5789C13.1603 21.0002 13.6316 20.5162 13.6316 19.9191V9.1083C13.6316 8.51124 13.1603 8.02722 12.5789 8.02722Z",
    stroke: "#6B798F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M4.68359 14.5131H9.94675M7.31517 11.8104V17.2158V11.8104Z",
    stroke: "#6B798F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.461238a021daea5020f57a5ec8736b18.svg";
export { ForwardRef as ReactComponent };